 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"addresses~combos~confirmation~debtorcards~profile~shipping_address~sign_in~sign_up":"addresses~combos~confirmation~debtorcards~profile~shipping_address~sign_in~sign_up","addresses~debtorcards~shipping_address~sign_up":"addresses~debtorcards~shipping_address~sign_up","addresses":"addresses","debtorcards":"debtorcards","profile~sign_in~sign_up":"profile~sign_in~sign_up","sign_up":"sign_up","shipping_address":"shipping_address","combos":"combos","confirmation":"confirmation","profile":"profile","sign_in":"sign_in","agencies":"agencies","basket_compare":"basket_compare","basket_page":"basket_page","category~home":"category~home","category":"category","home":"home","dispatch":"dispatch","error_layout":"error_layout","leaflets":"leaflets","order_index":"order_index","order_payment":"order_payment","order_show":"order_show","payment":"payment","product_page":"product_page","promotions":"promotions","search":"search","stokvel":"stokvel","terms_and_conditions ":"terms_and_conditions "}[chunkId]||chunkId) + "." + {"addresses~combos~confirmation~debtorcards~profile~shipping_address~sign_in~sign_up":"a60f96d3","addresses~debtorcards~shipping_address~sign_up":"482760fb","addresses":"ebb8bdcf","debtorcards":"e1220a0a","profile~sign_in~sign_up":"6d34e480","sign_up":"91a4d09b","shipping_address":"e7013c03","combos":"559687bd","confirmation":"4cf5e887","profile":"bb9f1d6f","sign_in":"8854a792","agencies":"2ad60ca6","basket_compare":"e75dde10","basket_page":"597f8ec8","category~home":"e1c95c23","category":"dc7cef18","home":"39a02682","chunk-96e6c15e":"8719d0fc","dispatch":"0f3e0d5e","error_layout":"ac8f4efa","leaflets":"b08d86d5","order_index":"687e740c","order_payment":"73d5f512","order_show":"8b029ae7","payment":"a7a93a12","product_page":"3060323f","promotions":"9eaf54a7","search":"d3cfcbcc","stokvel":"ba66a5f0","terms_and_conditions ":"82319765"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"addresses~combos~confirmation~debtorcards~profile~shipping_address~sign_in~sign_up":1,"addresses~debtorcards~shipping_address~sign_up":1,"profile~sign_in~sign_up":1,"sign_up":1,"shipping_address":1,"combos":1,"confirmation":1,"profile":1,"basket_compare":1,"basket_page":1,"category~home":1,"home":1,"chunk-96e6c15e":1,"leaflets":1,"order_show":1,"payment":1,"product_page":1,"promotions":1,"search":1,"stokvel":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"addresses~combos~confirmation~debtorcards~profile~shipping_address~sign_in~sign_up":"addresses~combos~confirmation~debtorcards~profile~shipping_address~sign_in~sign_up","addresses~debtorcards~shipping_address~sign_up":"addresses~debtorcards~shipping_address~sign_up","addresses":"addresses","debtorcards":"debtorcards","profile~sign_in~sign_up":"profile~sign_in~sign_up","sign_up":"sign_up","shipping_address":"shipping_address","combos":"combos","confirmation":"confirmation","profile":"profile","sign_in":"sign_in","agencies":"agencies","basket_compare":"basket_compare","basket_page":"basket_page","category~home":"category~home","category":"category","home":"home","dispatch":"dispatch","error_layout":"error_layout","leaflets":"leaflets","order_index":"order_index","order_payment":"order_payment","order_show":"order_show","payment":"payment","product_page":"product_page","promotions":"promotions","search":"search","stokvel":"stokvel","terms_and_conditions ":"terms_and_conditions "}[chunkId]||chunkId) + "." + {"addresses~combos~confirmation~debtorcards~profile~shipping_address~sign_in~sign_up":"e136f32d","addresses~debtorcards~shipping_address~sign_up":"367afd94","addresses":"31d6cfe0","debtorcards":"31d6cfe0","profile~sign_in~sign_up":"b2773837","sign_up":"9aea9177","shipping_address":"6eaf986f","combos":"21f5bf8c","confirmation":"72d2861f","profile":"9aea9177","sign_in":"31d6cfe0","agencies":"31d6cfe0","basket_compare":"8a62547f","basket_page":"2367b7a8","category~home":"77714ee2","category":"31d6cfe0","home":"6b396e76","chunk-96e6c15e":"8d7b32d2","dispatch":"31d6cfe0","error_layout":"31d6cfe0","leaflets":"2266ba35","order_index":"31d6cfe0","order_payment":"31d6cfe0","order_show":"312a8f77","payment":"40ca6e3c","product_page":"82f15903","promotions":"2ae3c420","search":"a7260ff6","stokvel":"e6ea47e0","terms_and_conditions ":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
